<template>
  <div class="father">
    <div class="select_div">
      <div class="select_title" @click="showSubView(1)" id="subview1">
        <p>全天候物业管理服务</p>
      </div>
      <div class="select_title" @click="showSubView(2)" id="subview2">
        <p>后勤整体运营服务</p>
      </div>
      <div class="select_title" @click="showSubView(3)" id="subview3">
        <p>企事业单位保洁服务</p>
      </div>
      <div class="select_title" @click="showSubView(4)" id="subview4">
        <p>一站式服务中心</p>
      </div>
    </div>
    <subview1 v-show="showSubView1"></subview1>
    <subview2 v-show="showSubView2"></subview2>
    <subview3 v-show="showSubView3"></subview3>
    <subview4 v-show="showSubView4"></subview4>
  </div>
</template>
<script>
import subview1 from "./ServiceSubView1.vue";
import subview2 from "./ServiceSubView2.vue";
import subview3 from "./ServiceSubView3.vue";
import subview4 from "./ServiceSubView4.vue";
export default {
  data() {
    return {
      position: 1,
      showSubView1: true,
      showSubView2: false,
      showSubView3: false,
      showSubView4: false,
    };
  },
  created() {},
  components: {
    subview1,
    subview2,
    subview3,
    subview4,
  },
  computed: {},
  mounted() {
    this.showSubView(this.position);
  },
  destroyed() {},
  methods: {
    showSubView(id) {
      this.position = id;
      this.showSubView1 = false;
      this.showSubView2 = false;
      this.showSubView3 = false;
      this.showSubView4 = false;
      $("#subview1").removeClass("active");
      $("#subview2").removeClass("active");
      $("#subview3").removeClass("active");
      $("#subview4").removeClass("active");

      switch (this.position) {
        case 1:
          this.showSubView1 = true;
          $("#subview1").addClass("active");
          break;
        case 2:
          this.showSubView2 = true;
          $("#subview2").addClass("active");
          break;
        case 3:
          this.showSubView3 = true;
          $("#subview3").addClass("active");
          break;
        case 4:
          this.showSubView4 = true;
          $("#subview4").addClass("active");
          break;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  margin: 5rem 0;
}

.select_div {
  cursor: pointer;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.select_title {
  background: var(--divGaryE250);
  width: 29.6rem;
  height: 6.7rem;

  p {
    font-size: 2.4rem;
    line-height: 6.7rem;
  }
}

.select_title:hover {
  background: var(--textBlue);
  color: white;
}

.active {
  background: var(--textBlue);
  color: white;
}

@media (max-width: 800px) {
  .select_title {
    margin:1rem;
  }
}
</style>